import { useQuery } from "@tanstack/react-query";
import { getProjectIssuesJira } from "../api/timeEntryApi";
import { timeEntryKeys } from "../api/timeEntryKeys";

// Obtiene las issues Jira de un proyecto.
// Solo se ejecuta cuando projectId es un valor positivo válido. Ver useProjectIssues.ts
// para el porqué de `Number(...)` en vez de la comparación directa `projectId > 0`.
export const useProjectIssuesJira = (projectId: number | string | undefined) =>
  useQuery({
    queryKey: timeEntryKeys.projectIssuesJira(projectId),
    // `enabled` impide que la query corra sin projectId válido, así que dentro de
    // queryFn ya no puede ser undefined.
    queryFn: () => getProjectIssuesJira(projectId!),
    enabled: Boolean(projectId) && Number(projectId) > 0,
  });
